import themesApi from './api';
import themesToasts from './toasts';

export default [themesApi(), themesToasts()];
